module.exports = __webpack_public_path__ + "img/robot@2x.6326abf9.png";